<template>
    <button
        v-tippy="t('editorRedo')"
        :class="[buttonState(editor.can().redo()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().redo()"
        @click="editor.chain().focus().redo().run()"
    >
        <MdiRedo class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import { MdiRedo } from 'materialdesignicons-vue3/icons/';

    defineExpose({
        name: 'RedoButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
